module.exports = __webpack_public_path__ + "public/SiteIcons/double-quotes.png?b936eb98";